import { makeRequest } from 'utils/requestLogger';

export default () =>
    makeRequest('get', '/api/roundtables/recents');


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/getRoundtables.js